export default __webpack_public_path__ + "static/media/score.affb8409.svg";